import './index.scss';
import '@vfde-brix/unordered-vertical-list/dist/styles.css';
import { createUnorderedVerticalList } from '@vfde-brix/unordered-vertical-list';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-unordered-vertical-list', createUnorderedVerticalList, NO_PATTERN_BUSINESS_LOGIC);

import '@vfde-brix/unordered-horizontal-list/dist/styles.css';

import { createUnorderedHorizontalListComponent } from '@vfde-brix/unordered-horizontal-list';

createComponents('brix-unordered-horizontal-list', createUnorderedHorizontalListComponent, NO_PATTERN_BUSINESS_LOGIC);

import '@vfde-brix/image-header/dist/styles.css';
import '@vfde-brix/highlight-badge/dist/styles.css';

import { createImageHeaderComponent } from '@vfde-brix/image-header';

createComponents('brix-image-header', createImageHeaderComponent, NO_PATTERN_BUSINESS_LOGIC, element => element);

if ((window as any).VF !== undefined) {
    // console.log((window as any).VF.BRIX);

    if ((window as any).VF.BRIX === undefined) {
        (window as any).VF.BRIX = {};
    }

    (window as any).VF.BRIX.createImageHeaderComponent = createImageHeaderComponent;
}

import '@vfde-brix/offer-price/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/promo-price/dist/styles.css';
import '@vfde-brix/tooltip/dist/styles.css';
import '@vfde-brix/offer-price/dist/styles.css';
